// https://app.growthbook.io/features/prcng-1079_v1
export const EXPERIMENT_FLAG = 'prcng-1079_v1'
